import React, { ReactNode } from "react";

type ReadonlyIdentifierFieldProps = {
  label: string;
  children: ReactNode;
  className?: string;
};

/** Read-only form field styling shared by traceable lot and barcode values. */
export default function ReadonlyIdentifierField({
  label,
  children,
  className,
}: ReadonlyIdentifierFieldProps) {
  return (
    <div className={["min-w-0", className].filter(Boolean).join(" ")}>
      <label className="block text-sm font-medium text-gray-900">{label}</label>
      <div className="mt-1 flex min-h-[36px] items-center rounded-md border border-gray-300 bg-gray-50 px-3 shadow-sm sm:text-sm">
        {children}
      </div>
    </div>
  );
}
